import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9001Component } from './kymw9001.component';
import { GetAuthoritySetInfomationDetailService } from './api-services/get-authority-set-infomation-detail.service';
import { GetFunctionListService } from './api-services/get-function-list.service';
import { RegistAuthoritySetService } from './api-services/regist-authority-set.service';
import { UpdateAuthoritySetService } from './api-services/update-authority-set.service';
// import { GetAuthoritySetListService } from '../kymw9000/api-services/get-authority-set-list.service';　kymw9003 で改修のため一旦コメントアウト

/**
 * 権限セット情報詳細画面 モジュール設定クラス
 *
 * @export KYMW9001Module
 * @class KYMW9001Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9001Component,
  ],
  providers: [
    GetAuthoritySetInfomationDetailService,
    GetFunctionListService,
    RegistAuthoritySetService,
    UpdateAuthoritySetService,
    // GetAuthoritySetListService,　kymw9003 で改修のため一旦コメントアウト
  ],
})
export class KYMW9001Module {

}
